/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PortfolioType = {
    REPORT: 'report',
    PRE_TRADE: 'pre_trade'
} as const;
export type PortfolioType = typeof PortfolioType[keyof typeof PortfolioType];


export function instanceOfPortfolioType(value: any): boolean {
    for (const key in PortfolioType) {
        if (Object.prototype.hasOwnProperty.call(PortfolioType, key)) {
            if (PortfolioType[key as keyof typeof PortfolioType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PortfolioTypeFromJSON(json: any): PortfolioType {
    return PortfolioTypeFromJSONTyped(json, false);
}

export function PortfolioTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioType {
    return json as PortfolioType;
}

export function PortfolioTypeToJSON(value?: PortfolioType | null): any {
    return value as any;
}

export function PortfolioTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PortfolioType {
    return value as PortfolioType;
}

